// Getters
export const VERSIONS_SEARCH_RESULT = 'system/VERSIONS_SEARCH_RESULT'
export const DASHBOARD_BANNERS_SEARCH_RESULT = 'system/DASHBOARD_BANNERS_SEARCH_RESULT'
export const NEW_BANNER_SIDEBAR = 'system/NEW_BANNER_SIDEBAR'
export const ANNOUNCEMENT_TYPES = 'system/ANNOUNCEMENT_TYPES'
export const BUSINESS_UNITS_SEARCH_RESULT = 'system/BUSINESS_UNITS_SEARCH_RESULT'
export const BUSINESS_UNIT_SIDEBAR = 'system/BUSINESS_UNIT_SIDEBAR'

// Mutations
export const MUTATE_VERSIONS_SEARCH_RESULT = 'system/MUTATE_VERSIONS_SEARCH_RESULT'
export const MUTATE_DASHBOARD_BANNERS_SEARCH_RESULT = 'system/MUTATE_DASHBOARD_BANNERS_SEARCH_RESULT'
export const MUTATE_NEW_BANNER_SIDEBAR = 'system/MUTATE_NEW_BANNER_SIDEBAR'
export const MUTATE_ANNOUNCEMENT_TYPES = 'system/MUTATE_ANNOUNCEMENT_TYPES'
export const MUTATE_BUSINESS_UNITS_SEARCH_RESULT = 'system/MUTATE_BUSINESS_UNITS_SEARCH_RESULT'
export const MUTATE_BUSINESS_UNIT_SIDEBAR = 'system/MUTATE_BUSINESS_UNIT_SIDEBAR'

// Actions
export const SEARCH_VERSIONS = 'system/SEARCH_VERSIONS'
export const GET_VERSION = 'system/GET_VERSION'
export const SAVE_VERSION = 'system/SAVE_VERSION'
export const DELETE_VERSION = 'system/DELETE_VERSION'
export const SEARCH_DASHBOARD_BANNERS = 'system/SEARCH_DASHBOARD_BANNERS'
export const OPEN_NEW_BANNER_SIDEBAR = 'system/OPEN_NEW_BANNER_SIDEBAR'
export const STORE_DASHBOARD_BANNER = 'system/STORE_DASHBOARD_BANNER'
export const GET_DASHBOARD_BANNER = 'system/GET_DASHBOARD_BANNER'
export const DELETE_DASHBOARD_BANNER = 'system/DELETE_DASHBOARD_BANNER'
export const UPDATE_DASHBOARD_BANNER_SEQUENCE = 'system/UPDATE_DASHBOARD_BANNER_SEQUENCE'
export const GET_ANNOUNCEMENT_TYPES = 'system/GET_ANNOUNCEMENT_TYPES'
export const SEARCH_BUSINESS_UNITS = 'system/SEARCH_BUSINESS_UNITS'
export const GET_BUSINESS_UNIT = 'system/GET_BUSINESS_UNIT'
export const SAVE_BUSINESS_UNIT = 'system/SAVE_BUSINESS_UNIT'
export const DELETE_BUSINESS_UNIT = 'system/DELETE_BUSINESS_UNIT'
export const OPEN_BUSINESS_UNIT_SIDEBAR = 'system/OPEN_BUSINESS_UNIT_SIDEBAR'